import { render, staticRenderFns } from "./newsportage-videopicstext-swiper.vue?vue&type=template&id=4b41adcf&scoped=true"
import script from "./newsportage-videopicstext-swiper.vue?vue&type=script&lang=js"
export * from "./newsportage-videopicstext-swiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41adcf",
  null
  
)

export default component.exports